import callApi from '@/utils/callApi';
import state from '@/state';
import activity from '@/utils/activityTracker';

const tickDelay = 4000;
const tickDelayInactive = 12000;

const listeners = {
  newToasts: [],
  newNotificationCount: [],
};

const data = {
  newNotificationCount: 0,
};

async function tick () {
  if (! window.document.hasFocus()) {
    setTimeout(tick, 1000);
    return;
  }
  if (! state.customerToken) {
    // Not logged in = no notifications
    setTimeout(tick, 250);
    return;
  }

  try {
    await fetchNotifications();
    if (activity.isActive) {
      setTimeout(tick, tickDelay);
    } else {
      setTimeout(tick, tickDelayInactive);
    }
  } catch (e) {
    setTimeout(tick, 10000); // Let's assume the error is persistent or due to load, lets slow down
    console.error('Error during notification fetch: ' + e);
  }
}
setTimeout(tick, 500);

async function fetchNotifications () {
  if (listeners.newToasts.length > 0) { // Both count and toasts
    let url = '/v1/client/notifications/toasts?take=4';
    const res = await callApi('GET', url);
    const body = await res.json();

    if (body.events && body.events.length > 0) {
      for (const l of listeners.newToasts) {
        l(body.events);
      }
    }
    if (data.newNotificationCount !== body.count) {
      data.newNotificationCount = body.count;

      for (const l of listeners.newNotificationCount) {
        l(data.newNotificationCount);
      }
    }
  } else if (listeners.newNotificationCount.length > 0) { // only count
    let url = '/v1/client/notifications/new';
    const res = await callApi('GET', url);
    const body = await res.json();
    if (data.newNotificationCount !== body.count) {
      data.newNotificationCount = body.count;

      for (const l of listeners.newNotificationCount) {
        l(data.newNotificationCount);
      }
    }
  }
}


export default {
  getNewNotificationCount () {
    return data.newNotificationCount;
  },
  setNewNotificationCount (count) {
    data.newNotificationCount = count;
  },
  addEventListener (evtName, listener) {
    if (! (evtName in listeners)) {
      throw new Error('Invalid notification event name "' + evtName + '"');
    }
    listeners[evtName].push(listener);
  },
  removeEventListener (evtName, listener) {
    if (! (evtName in listeners)) {
      throw new Error('Invalid notification event name "' + evtName + '"');
    }
    const index = listeners[evtName].indexOf(listener);
    if (index >= 0) {
      listeners[evtName].splice(index, 1);
    }
  },
};
